import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class RecentImage extends Component {
    render() {
        return (
            <div className="widget-recent-work widget-ft">
                <h6 className="widget-title">RECENT WORK</h6>
                <div className="flat-recentOwl" data-column={4} data-column2={3} data-loop="true" data-column3={2} data-gap={0}
                    data-dots="false" data-nav="true">
                    <div className="flat-imgbox style1 clearfix owl-carousel">
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                                <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-1.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-5.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-2.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-6.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-3.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-7.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-4.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-8.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-1.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-2.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-3.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-4.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-5.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-6.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="column">
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-7.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="imgbox style1 transition-vline">
                            <Link to={'//www.pinterest.com/pin/563161128409578207/'} target="_blank">
                                    <div className="imgbox-img img-vline">
                                        <img src="images/footer/work-8.jpg" alt="bookflare" />
                                        <div className="overlay">
                                            <span className="vline" />
                                            <span className="vline vline-bottom" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wrap-btn">
                    <Link to={'//www.pinterest.com'} target="_blank" className="btn-view-more">VIEW MORE</Link>
                </div>
            </div>
        );
    }
}

export default RecentImage;